import { render, staticRenderFns } from "./models.vue?vue&type=template&id=5ca0cfc4&scoped=true&"
import script from "./models.vue?vue&type=script&lang=js&"
export * from "./models.vue?vue&type=script&lang=js&"
import style0 from "./models.vue?vue&type=style&index=0&id=5ca0cfc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0cfc4",
  null
  
)

export default component.exports